import { axios } from "../../../lib/axios"

export const joinWaitingRoom = (request) => {
    return axios.post(`encounter`, request);
}